// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	const HEADER = document.querySelector('#header');
	let defaultTextTPL = document.querySelector('body#default-text');
	let galleryTPL = document.querySelector('body#gallery-flex');
	let attractionsTPL = document.querySelector('body#attractions');
	let contactUsTPL = document.querySelector('body#contact-us');
	let introContent = document.querySelector('body .intro-content');

	if(introContent && introContent.classList.contains('noTop')){
		HEADER.classList.add('scrolled');
	}
	if(defaultTextTPL || galleryTPL || attractionsTPL || contactUsTPL){
		HEADER.classList.add('scrolled');
	}

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

	// PARALLAX ANIMATION *****************************************************/

	const scrollParallax = {};

	const v_height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

	function doParallax(elm) {
	let bounds = elm.dataset.parallax.split(",").map(Number);
	let distance = bounds[1] - bounds[0];
	let unit_scroll = distance / (v_height + elm.offsetHeight);

	let topElement = elm.getBoundingClientRect().top + window.pageYOffset;

	let beforeSpeed = parseFloat(elm.dataset.parallaxSpeedBefore) || 1.0;
	let afterSpeed = parseFloat(elm.dataset.parallaxSpeedAfter) || 1.0;

	let parallaxFunction = function () {
		let scrolled = window.pageYOffset;
		let relative_distance = scrolled + v_height - topElement;
		let temp = unit_scroll * relative_distance + bounds[0];

		elm.style.transform = `translate(0, ${temp}px)`;
	};

	scrollParallax[elm.dataset.parallaxid] = parallaxFunction;

	window.addEventListener('scroll', scrollParallax[elm.dataset.parallaxid]);
	}

	let observers_parallax_elements = document.querySelectorAll(".js-prllx-el");
	observers_parallax_elements.forEach((elm) => {
	doParallax(elm);
	});

	const options_parallax = {
	root: null,
	rootMargin: '0px',
	threshold: 0,
	};

	function handler_parallax(entries) {
		entries.forEach((entry) => {
			const target = entry.target;
			const id_elem = target.dataset.parallaxid;

			if (entry.isIntersecting) {
			doParallax(target);
			} else {
			window.removeEventListener('scroll', scrollParallax[id_elem]);
			}
		});
	}

	const observable_parallax = new IntersectionObserver(handler_parallax, options_parallax);
	let counter = 1;

	observers_parallax_elements.forEach((element) => {
	observable_parallax.observe(element);
	element.dataset.parallaxid = counter;
	counter++;
	});

	// SHOW SUBMENU FUNCTION: 
	const submenuToShow = (linksSelector, linkSubmenu) => {
		let navLinks = document.querySelectorAll(linksSelector); 
		let submenu_active = document.querySelectorAll(linkSubmenu); 

		navLinks.forEach(link => {
			const parent = link.parentNode;
			let submenu = parent.querySelector('.submenu');
			link.addEventListener('click', (e) => {
				link.classList.toggle('active');
				submenu.classList.toggle('active');
			});
		});
		submenu_active.forEach(sub => {
			if (sub.classList.contains('active')) {
				if (window.screen.width > 640) {
					let selectedLink = sub.parentNode.parentNode.parentNode.children[0];
					selectedLink.classList.add('selected');
				}else{
					let selectedLink = sub.parentNode.parentNode.parentNode.parentNode.children[0];
					selectedLink.classList.add('selected');
				}
			}

		})
	}

	if (window.screen.width > 640) {
		submenuToShow('#primary-nav li a', '.submenu li a');
	} else {
		submenuToShow('.mobileMenu__nav li a', '.sub-sub-menu .submenu li a');
	}
	// Menu Functionality

	let menuContent = document.getElementById("navigationBox");
	//Open/CLose
	if(menuContent){
		let header = document.getElementById("header");
		let menuBtn = document.querySelector("[data-open_nav]");	
		let closeBtn = document.querySelector("[data-close_nav]");	
		let body = document.querySelector('body');
		menuBtn.addEventListener('click', function (e) {			
			menuBtn.classList.add("open");
			menuContent.classList.add("open");
			header.classList.add("menuOpen");
			body.classList.add("no-overflow");
			// if(document.querySelector('#navMenuBar')){
			// 	document.querySelector('#navMenuBar').classList.toggle("open");
			// }
		});

		closeBtn.addEventListener('click', function (e) {			
			closeBtn.classList.remove("open");
			menuContent.classList.remove("open");
			header.classList.remove("menuOpen");
			body.classList.remove("no-overflow");	
		});

	}

	// SPLIT CURSIVE TITLE TEXT
	document.querySelectorAll('.broke').forEach(span => {
		// let h2Span = span.querySelector('span').innerHTML;
		let h2elements = span.childNodes;
		let h2elementsAsArray = [...h2elements];
		
		span.innerHTML = '';
		h2elementsAsArray.forEach(char =>{
			if(char.innerHTML == undefined){
				let phrase = '';
				char.textContent.trim().split('').forEach(word => {
					phrase += `<span class="chara">${word}</span>`;
				});
				span.innerHTML += phrase;
			}else{
				let phraseSpan = `<span class="subtitle">`;
				char.textContent.trim().split('').forEach( word => {					
					phraseSpan += `<span class="sbt_chara">${word}</span>`;
				})
				phraseSpan += `</span>`
				span.innerHTML += phraseSpan;				
			}
		});
	});

	// Full Quad Tabs Functionality
	let fullQuadTabs = document.querySelectorAll('.full-quad-tabs');
	
	if(fullQuadTabs.length > 0){
		
		fullQuadTabs.forEach(fullQuadTabsQuad => {
			let tabs = document.querySelectorAll(".full-quad-tabs__preview-content--tabs h2");
			let goBackBtn = document.querySelector('#goBack');
			tabs.forEach(tab => {
				tab.addEventListener('click', function (e) {
					e.preventDefault();		
					goBackBtn.classList.add('active');
					let currenTab = this.getAttribute("data-tab");
					document.querySelectorAll(`.full-quad-tabs__preview-content--tabs h2[data-tab="${currenTab}"] `).forEach(item => { item.classList.add('active'); });
					document.querySelectorAll(`.full-quad-tabs__tabs-content[data-tab="${currenTab}"] `).forEach(item => { item.classList.add('show'); });
				});      
			});
			goBackBtn.addEventListener('click', function(e){
				e.preventDefault();		
				this.classList.remove('active');
				document.querySelectorAll(".full-quad-tabs__preview-content--tabs h2[data-tab]").forEach(item => { item.classList.remove('active'); });
				document.querySelectorAll(".full-quad-tabs__tabs-content[data-tab]").forEach(item => { item.classList.remove('show'); });
			});
		});
	}

	// Accordion
	let allAccordionItems = document.getElementsByClassName('js-accordion-title');
	let allALength = allAccordionItems.length;

	for(let i =0; i < allALength; i++){
		allAccordionItems[i].addEventListener('click', function(){
			let currentParent = this.parentElement;
			let currentCopyHeight = currentParent.getElementsByClassName('wrap')[0].clientHeight;
			let currentCopy = currentParent.getElementsByClassName('js-accordion-copy')[0]
			if(currentParent.classList.contains('open')){
				currentParent.classList.remove('open');
				currentCopy.style.height = '0';
			} else {
				for(let i =0; i < allALength; i++){		
					let allParents = allAccordionItems[i].parentElement;
					let allCopy = allParents.getElementsByClassName('js-accordion-copy')[0];
					allParents.classList.remove('open');
					allCopy.style.height = '0';
				}	

				currentParent.classList.add('open');
				currentCopy.style.height = currentCopyHeight + 'px';
			}
		})
	}

	//// Forms animation for labels   ----------------------------------------------------------------
	if (document.getElementById('email-signup_FNAME')) {
		document.getElementById('email-signup_FNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_LNAME')) {
		document.getElementById('email-signup_LNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	//CMS forms label animation ----------------------------------------------------------------
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'time' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

	// Menus Live Text
	if(document.getElementsByClassName("menu-quad")[0]){
		let menuCategories = document.querySelectorAll(".menu-quad .menu-quad__tabs .js-menu-tab");
		let menusSelector = document.getElementById("menusSelector");
		let currentMenuTitle = document.getElementById('currentMenu');
		
		let ulMenu = document.querySelector(".menu-quad ul");
		for(let c = 0; c < menuCategories.length; c++){
			menuCategories[c].addEventListener('click', function (e) {
				e.preventDefault();		
				let currentCat = this.getAttribute("data-tag");
				document.querySelectorAll(".menu-quad [data-tag]").forEach(item => { item.classList.remove('active'); })
				document.querySelectorAll(`.menu-quad [data-tag="${currentCat}"] `).forEach(item => { item.classList.add('active'); })

				currentMenuTitle.innerText = currentCat;
				if(menusSelector){
					menusSelector.value = currentCat;
				}
				ulMenu.classList.remove("open");

			});
			menuCategories[0].click();
		};
		if(menusSelector){
			menusSelector.addEventListener('click', function () {	
				ulMenu.classList.toggle("open");
			})
		}        

	}

	
	document.addEventListener('DOMContentLoaded', () => {
		let btn = document.querySelectorAll('.btn, .btn_white, .btn_brick, .signup-btn');
		btn.forEach(btn => {
			btn.innerHTML = `<span class="label">${btn.innerText}</span>`;
		});

		const customLightbox = new LBX('.js-lbx-copy', {
            customClass: 'lbx-copy',
        });
	})

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
		}
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
/** ADA - Add aria-label to Footer Navigation **/
document.addEventListener("DOMContentLoaded", function () {
	const secondaryNavFooter = document.querySelector(".footer__top #secondary-nav");
	if (secondaryNavFooter) {
		secondaryNavFooter.setAttribute("aria-label", "Secondary Footer Navigation");
	}
});

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
	const menu = document.querySelector('#navigationBox');
	const isMenuVisible = menu && menu.classList.contains('open');
	const elements = document.querySelectorAll('.menu-block .privary-navigation__item a, .menu-block .secondary-navigation__item a, .menu-block .social-media a');

	elements.forEach(element => {
		element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
	});
}

document.addEventListener('DOMContentLoaded', () => {
	updateMenuTabIndex();

	document.addEventListener('focusin', updateMenuTabIndex);
	const menu = document.querySelector('#menu');
	if (menu) {
		menu.addEventListener('transitionend', updateMenuTabIndex);
	}
});
